<div class="tabbed-dialog-layout">
  <app-tabs #tabs class="tabbed-dialog-tabs">
    <app-tab class="tab-with-fixed-footer" [tabTitle]="translate('firmData')" tabId="tabFirmData">
      <app-firm-data
        class="tabbed-dialog-pane"
        [firmData$]="firmData$ | async"
        (updateFirmEvent)="updateFirmData($event)">
      </app-firm-data>
    </app-tab>
    <app-tab [tabTitle]="translate('firmUser')" tabId="tabFirmUsers">
      <app-firm-users></app-firm-users>
    </app-tab>
    <app-tab [tabTitle]="translate('taskTemplates')" tabId="tabTaskTemplates" *appHideIfCountries="'NL'">
      <app-firm-task-templates></app-firm-task-templates>
    </app-tab>
    <ng-container *ngIf="firmAssignmentData$ | async as firmSettings">
      <app-tab
        class="tab-with-fixed-footer"
        [tabTitle]="translate('assignmentSettings')"
        tabId="tabAssignmentSettings"
        *appHideIfCountries="'NL'">
        <app-firm-assignment-settings
          class="tabbed-dialog-pane"
          [firmAssignmentData$]="firmSettings"
          (updateFirmAssignmentData)="updateFirmAssignmentData($event)"
          (resetFirmAssignmentData)="resetFirmAssignmentData()">
        </app-firm-assignment-settings>
      </app-tab>
    </ng-container>
    <app-tab
      class="tab-with-fixed-footer"
      [tabTitle]="translate('bulkHandling')"
      [tabTooltip]="translate('bulkHandlingTooltip')"
      tabId="tabBulkHandling"
      [disabled]="!hasRightsToChange()"
      (activeChange)="bulkHandlingTabActive = $event;"
      *appHideIfCountries="'NL'">
      <app-bulk-main class="tabbed-dialog-pane" [tabActive]="bulkHandlingTabActive"></app-bulk-main>
    </app-tab>

    <app-tab
      [tabTitle]="translate('teamManagement')"
      [tabTooltip]="translate('teamManagementTooltip')"
      tabId="tabTeams"
      [disabled]="!hasRightsToChange()"
      (activeChange)="teamTabActive = $event;">
      <app-teams *ngIf="teamTabActive"></app-teams>
    </app-tab>

    <app-tab [tabTitle]="translate('systemSettings')" tabId="tabFirmSystemSettings">
      <app-firm-system-settings></app-firm-system-settings>
    </app-tab>

    <app-tab
      class="tab-with-fixed-footer"
      [tabTitle]="translate('import')"
      tabId="tabFileImport"
      (activeChange)="fileImportTabActive = $event"
      ><app-file-import class="tabbed-dialog-pane" [tabActive]="fileImportTabActive"></app-file-import
    ></app-tab>

    <ng-container *appHideIfCountries="'NL'">
      <app-tab *appAdminPrivilege [tabTitle]="translate('firmAdminTools')" tabId="tabFirmAdminTools">
        <app-firm-reset [closeCallback]="resetCallback"></app-firm-reset>
      </app-tab>
    </ng-container>
  </app-tabs>
</div>
